import service from '@/common/global'

// 登录
export function APILOGIN (params) {
  return service.post(`/api/record/signUp`, params).then((res) => {
    if (res.data.status === 1) {
      return res.data
    } else {
      return Promise.reject(res.data)
    }
  })
}

// 测评记录查询 api/record/getRecordInfoByAccount
export function APIRECORDINFO (params) {
  return service.post(`api/record/getRecordInfoByAccount`, params).then((res) => {
    if (res.data.status === 1) {
      return res.data
    } else {
      return Promise.reject(res.data)
    }
  })
}

// 获取要导出的地址
export function APIEXPORTUNFINISH (params) {
  return service.post(`/api/checkExportUnfinished`, params).then((res) => {
    if (res.data.status === 1) {
      return res.data
    } else {
      return Promise.reject(res.data)
    }
  })
}

//获取未完成名单getEvaluationProgress GETEVALUTAIONPROGRESS
export function APIGETEVALUTAIONPROGRESS (params) {
  return service.post(`/api/schoolPlan/getEvaluationProgress`, params).then((res) => {
    if (res.data.status === 1) {
      return res.data
    } else {
      return Promise.reject(res.data)
    }
  })
}
//获取未完成名单getEvaluationProgress GETEVALUTAIONPROGRESS
export function APIGETRECHECKLIST (params) {
  return service.post(`/api/recheck/getRecheckRosterList`, params).then((res) => {
    if (res.data.status === 1) {
      return res.data
    } else {
      return Promise.reject(res.data)
    }
  })
}
// 下载异常作答的名单
export function APIEXPORTEXCEPTIONDATA(params){
  return service.post(`/api/checkExportExceptionData`,params).then((res) => {
      if (res.data.status === 1) {
        return res.data
      } else {
        return Promise.reject(res.data)
      }
  }).catch((err) => {
    console.log(err);
  })
}
//获取学校的学段
export function APIGETSECTIONOPTIONS (params) {
  return service.post(`/api/getSectionList`, params).then((res) => {
    if (res.data.status === 1) {
      return res.data
    } else {
      return Promise.reject(res.data)
    }
  })
}
//获取学校的年级
export function APIGEGRADEOPTIONS (params) {
  return service.post(`/api/getGradeList`, params).then((res) => {
    if (res.data.status === 1) {
      return res.data
    } else {
      return Promise.reject(res.data)
    }
  })
}
//获取学校的班级
export function APIGETCLASSOPTIONS (params) {
  return service.post(`/api/getClassList`, params).then((res) => {
    if (res.data.status === 1) {
      return res.data
    } else {
      return Promise.reject(res.data)
    }
  })
}